import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { CheckCircle2Icon } from 'lucide-react';
export function Benefits() {
  const {
    benefits
  } = pageData;
  return <section className="py-24 px-4" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl mb-6" data-id="element-23">
            {benefits.heading}
          </motion.h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-24">
            {benefits.intro}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-25">
          {benefits.items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex gap-4" data-id="element-26">
              <div className="shrink-0 mt-1" data-id="element-27">
                <CheckCircle2Icon className="w-6 h-6 text-gold-500" data-id="element-28" />
              </div>
              <div data-id="element-29">
                <h3 className="text-xl mb-2 text-white" data-id="element-30">{item.title}</h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-31">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}